export default function(window, maxInput) {

    let listeners = [],
        history = [],
        currentHistoryIndex = 0,
        currentInput = "",
        cursorColumn = 0,
        enabled = true;

    maxInput = maxInput || 40;

    function emit() {
        listeners.forEach(x => x(currentInput));
    }

    function reset() {
        currentHistoryIndex = history.length;
        currentInput = "";
        cursorColumn = 0;
    }

    function keyup(evt) {
        // console.log(`Key: ${evt.key}, keyCode: ${evt.keyCode}, code: ${evt.code}`);

        if (!enabled) {
            return;
        }

        if (evt.keyCode == 13) {
            emit();
            history.push(currentInput);
            reset();
        } else if (evt.key === "Escape") {
            reset();
        } else if (evt.key === "Backspace") {
            if (cursorColumn > 0) {
                currentInput = currentInput.substring(0, cursorColumn - 1) + currentInput.substring(cursorColumn);
                cursorColumn--;
            }
        } else if (evt.key === "Delete") {
            if (cursorColumn < currentInput.length) {
                currentInput = currentInput.substring(0, cursorColumn) + currentInput.substring(cursorColumn + 1);
            }
        } else if (evt.keyCode >= 37 && evt.keyCode <= 40) {
            switch(evt.keyCode) {
                case 37:
                    cursorColumn = Math.max(cursorColumn - 1, 0);
                    break;
                case 38:
                    currentHistoryIndex = Math.max(0, currentHistoryIndex - 1);
                    currentInput = history[currentHistoryIndex];
                    cursorColumn = currentInput.length;
                    break;
                case 39:
                    cursorColumn = Math.min(cursorColumn + 1, currentInput.length);
                    break;
                case 40:
                    currentHistoryIndex = Math.min(history.length, currentHistoryIndex + 1);
                    if (currentHistoryIndex === history.length) {
                        currentInput = "";
                    } else {
                        currentInput = history[currentHistoryIndex];
                    }
                    cursorColumn = currentInput.length;
                    break;
            }
        } else if (
            (evt.keyCode >= 32 && evt.keyCode <= 255) &&
            evt.key.length === 1
        ) {
            if (currentInput.length < maxInput) {
                currentInput = currentInput.substring(0, cursorColumn) +
                            evt.key + 
                            currentInput.substring(cursorColumn);
                cursorColumn++;
            }
        }
    }

    window.addEventListener("keydown", keyup);
 
    return {
        register(listener) {
            listeners.push(listener);
        },
        currentInput() {
            return currentInput;
        },
        cursorColumn() {
            return cursorColumn;
        },
        inputEnabled() {
            return enabled;
        },
        disable() {
            enabled = false;
        },
        enable() {
            enabled = true;
        }
    }
};
